module.exports = __webpack_public_path__ + "static/media/hat-wizard.2de93f25.svg";